module.exports = __webpack_public_path__ + "img/female_appearance.e0e07c01.png";